import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const LandingPage = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        marginTop: "100px",
        backgroundImage: "url()",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Container>
        <Typography
          variant="h2"
          component="h1"
          align="center"
          sx={{
            color: "#fff",
            fontWeight: "bold",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
          }}
        >
          欢迎登录
        </Typography>
        <Typography
          variant="h5"
          component="p"
          align="center"
          sx={{
            color: "#fff",
            mt: 2,
            textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
          }}
        >
          请登录以继续使用我们的应用
        </Typography>
      </Container>
    </Box>
  );
};

export default LandingPage;
